import React from "react";

// export const Team = (props) => {
//   return (
//     <div id="team" className="text-center">
//       <div className="container">
//         <div className="col-md-8 col-md-offset-2 section-title">
//           <h2>Conozca nuestro equipo</h2>
//           <p>
//             Nuestro equipo está dedicado a brindar la mejor experiencia en el alquiler
//             de quinchos y espacios para eventos.
//           </p>
//         </div>
//         <div id="row">
//           {props.data
//             ? props.data.map((d, i) => (
//                 <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
//                   <div className="thumbnail">
//                     {" "}
//                     <img src={d.img} alt="..." className="team-img" />
//                     <div className="caption">
//                       <h4>{d.name}</h4>
//                       <p>{d.job}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             : "loading"}
//         </div>
//       </div>
//     </div>
//   );
// };
export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Conozca nuestro equipo</h2>
          <p>
            Nuestro equipo está dedicado a brindar la mejor experiencia en el alquiler
            de quinchos y espacios para eventos.
          </p>
        </div>
        {/* <div className="row justify-content-center"> */}
        <div className="d-flex flex-wrap justify-content-center">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 col-sm-6 team mb-4">
                  <div className="thumbnail text-center">
                    <img src={d.img} alt={d.name} className="team-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "Cargando..."}
        </div>
      </div>
    </div>
  );
};
